export const LOCAL_STORAGE = {
  LANG: 'language',
  TOKEN: 'token',
  TOKEN_KEY: 'token_key',
  UUID: 'uuid',
  USER_IP: 'User-Ip',
  LAST_TOKEN_REFRESH: 'last_token_refresh',
  PROFILE_TYPE: 'profile_type',
  EXTERNAL_USER_MODAL_BEHAVIOUR: 'external_user_modal_behaviour',
};

export const SESSION_STORAGE = {
  REDIRECT_URL: 'postAuthRedirect',
};

export const APP_NAME = 'web-epak';

export const defaultUrlParams = {
  sort_order: 'DESC',
  sort_field: 'id',
  limit: 10,
  page: 1,
};

export const tabsServices = [
  { key: 'data_entry', title: 'DATA_ENTRY', tooltipText: 'data_entry2624' },
  { key: 'documents', title: 'DOCUMENTS', tooltipText: 'Documents2624' },
  { key: 'overview', title: 'OVERVIEW', tooltipText: 'overview2624' },
  // { key: 'payment', title: 'PAYMENT' },
  { key: 'success', title: 'SUCCESS', tooltipText: 'success2624' },
];

export const AUTOSAVE_DEBOUNCE = 500;

export const MAX_CHILDS_DEPTH = 5;
